import { unsafeHTML } from "lit/directives/unsafe-html.js";
import { Handlebars } from "../handlebars-helpers";
import { LANGUAGES } from "../../api-sdk/types";
import { localizeUserString } from "../localize";

const DEFAULT_LANGUAGE_CODE = "en";

/**
 * Compile a string through Handlebars and return the raw HTML string.
 * If `context.lang` is set, the string is first passed through localizeUserString
 * so JSON-encoded multilingual strings ({"en":"...","fr":"..."}) are resolved
 * before Handlebars processes them — no call to localizeUserString needed at call sites.
 */
const compileUserString = (str: string, context: Record<string, unknown> = {}, fallback = ""): string => {
  const lang = (context.lang || DEFAULT_LANGUAGE_CODE) as LANGUAGES;
  const source = str || fallback;
  const localized = localizeUserString(lang, source) ?? source;
  return Handlebars.compile(localized)(context);
};

/**
 * Compile a string through Handlebars and return a Lit TemplateResult safe for rendering HTML.
 * Equivalent to unsafeHTML(compileUserString(str, context, fallback)).
 */
const renderUserString = (str: string, context: Record<string, unknown> = {}, fallback = "") =>
  unsafeHTML(compileUserString(str, context, fallback));

export { compileUserString, renderUserString };
